import React from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import downloadFiles from "../FilesRelevent/DownloadFiles";
import PdfPreview from "./PdfPreview";

export default function ModelContractPost({ setContact, proposalmilestones }) {
console.log("proposalmilestones", proposalmilestones);
  return (
    <div className="rent-product">
      <div className="modal-head">
        {/* {proposalmilestones?.agreement_pdf} */}
        <h6>Contract Details</h6>
        <button onClick={() => setContact((state) => !state)} className="btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
            alt=""
          />
        </button>
      </div>
      {proposalmilestones?.agreement_pdf ? (
        <>
          {/* <img
            style={{ width: "100%", height: "100%" }}
            src={proposalmilestones?.agreement_pdf}
            alt=""
          /> */}
          {/* <embed
            src={proposalmilestones?.agreement_pdf}
            type="application/pdf"
            width="100%"
            height="600px"
          /> */}
          <embed
            src={`${proposalmilestones?.agreement_pdf}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
            type="application/pdf"
            width="100%"
            height="600px"
          />


          {/* <PdfPreview pdfUrl={proposalmilestones?.agreement_pdf} /> */}

          <button
            onClick={() => downloadFiles(proposalmilestones?.agreement_pdf)}
            className="btn w-100 submit-req"
          >
            Download
          </button>
        </>
      ) : (
        // <i className="fa fa-spinner fa-spin" style={{ fontSize: "150px" }}></i>
        <h6>No Contract to Display</h6>
      )}
    </div>
  );
}
